import React, { Component } from 'react'
import { Modal, Timeline, Form, message } from 'antd'
import moment from 'moment'
import * as utils from 'utils/index'
import { sagaModal } from 'redux-saga-modal'
import * as services from '@/models/orders/services';
@Form.create()
class ExpressDetail extends Component {
  state = { data: [] }
  componentDidMount() {
    this.fetchExpressDetail();
  }
  getLabel = (it) => {
    return <><span>{utils.expressStatusMainCode[it.logisticsStatus] + ' ' + moment(it.time).format('YYYY-MM-DD HH:mm:ss')}</span>
      <br></br>
      {it.desc}
    </>
  }
  fetchExpressDetail = () => {
    const params = this.props
    const query = {
      expressCompanyCode: params.expressCompanyCode,
      expressNo: params.expressNo,
      mobile: params.mobile,
    }
    services.queryExpress(query)
      .then((result) => {
        if (result == null) {
          // message.error('获取快递明细失败，请检查快递接口');
        } else {
          this.setState({ data: result?.logisticsTraceDetails.reverse() })
        }
      })
      .catch((err) => {
        // message.error(err.message || '获取快递明细失败，请刷新重试');
      })
      .finally(() => {
        //setLoading(false);
      });
  }
  render() {

    return (
      <Timeline>
        {this.state.data?.map(it => {
          return <Timeline.Item key={it.time} color="green">{this.getLabel(it)}</Timeline.Item>
        })}
      </Timeline>
    )
  }
}

function showExpressDetailDialog({
  modal: {
    name,
  },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={500}
      style={{ top: '30vh' }}
      visible={isOpen}
      onCancel={hide}>
      <ExpressDetail {...ownProps} submit={submit} />
    </Modal>
  )
}

export default sagaModal({
  name: 'EXPRESS_DETAIL_DIALOG',
})(showExpressDetailDialog)
